<template lang="html">
    <div :style="maintenance ? 'height: 100vh' : ''">
        <PullRefresh />
        <MaintenancePage v-if="maintenance" />
        <template v-else>
            <div 
                class="mobile-overlay" 
                :style="{
                    display: styles.overlay.active ? 'block' : 'none'
                }" 
                @click="toggleSidebar(!styles.overlay.active)">
            </div>
            <UiNotification />
            <div class="sidebar" id="sidebar"
                :class="{
                    'sidebar--collapsed': !styles.sidebar.active
                }"
                style="z-index: 30">
                <i v-if="styles.closeIcon.active"
                    class="sidebar__close fas fa-times" 
                    id="sidebar-close" 
                    @click="toggleSidebar"/>

                <div class="sidebar__logo">
                    <img src="@/assets/images/logo.svg" alt="">
                </div>

                <NextAppointment v-if="widget && widget.appointment" :key="widget.appointment.id" @openJoinMeeting="showMeetingJoinModal"/>
                
                <AnytimeWidget v-if="anytimeWidget && anytimeWidget.meeting" />

                <div class="sidebar__menu-items">
                    <div class="menu-item" 
                        v-for="item in items" :key="item.name" @click="selectSidebarItem(item)"
                        :class="{
                            'menu-item--active':
                                ($router.currentRoute.name == item.name) ||
                                (
                                    item.name == 'Disponibilitate' &&
                                    $router.currentRoute.hash === '#disponibilitate'
                                )
                        }">
                        <i :class="item.icon"></i>
                        <span class="menu-item__name">{{item.name}}</span>
                        
                        <template v-if="item.hasCounter">
                            <!-- Swich between cases -->
                            <div class="menu-item__counter" v-if="anytimeMeetingSidebarCounter > 0"
                                :class="{
                                    'menu-item__counter--active': $router.currentRoute.name == item.name
                                }">
                                {{ anytimeMeetingSidebarCounter }}
                            </div>
                        </template>
                    </div>
                </div>
                <div class="sidebar__info">
                    <span class="sidebar__info-text" v-if="user">
                        <img src="@/assets/images/icons/coins.svg" style="color: black;" alt=""> 
                        {{user.balance}} 
                        <template v-if="services">
                            <span style="font-weight: 300; margin: 0px 3px;">|</span> 
                            {{services.length}} Şedinte
                        </template>    
                    </span>
                </div>

                <Footer />
            </div>
            <div class="container"
                id="main-container"
                :style="{
                    paddingLeft: styles.container.paddingLeft,
                    paddingRight: 0
                }">

                <Navbar
                    :isMobile="isMobile()" 
                    @change="toggleSidebar($event)"
                />
                
                <router-view @openJoinMeeting="showMeetingJoinModal"></router-view>
            </div> 
            <BillingDetailsModal v-if="$store.state.layout.billingDetailsModal.active"/>
            <PaymentModal v-if="$store.state.payments.modal.active"/>
            <MeetingJoinModal v-if="showMeetingJoin" @close="showMeetingJoin = !showMeetingJoin"/>
            <audio style="display: none;" preload="none" id="new-appointment-audio" v-if="user.role == 'specialist'">
                <source src="@/assets/audio/newappointment.mp3" type="audio/mpeg">
            </audio>
            <audio style="display: none;" preload="none" id="anytime-new-user" v-if="user.role == 'specialist'">
                <source src="@/assets/audio/queueupdates.mp3" type="audio/mpeg">
            </audio>
        </template>
    </div>
</template>

<script>
//import VuePullRefresh from 'vue-pull-refresh';
import PullRefresh from '@/layouts/Dashboard/components/PullRefresh'
import Navbar from '@/layouts/Dashboard/components/Navbar'
import Footer from '@/layouts/Dashboard/components/Footer'
import PaymentModal from '@/layouts/Dashboard/components/PaymentModal'
import MeetingJoinModal from '@/layouts/Dashboard/components/MeetingJoinModal'
import UiNotification from '@/components/ui/Notification'
import MaintenancePage from '../../pages/Maintenance';
import NextAppointment from '@/layouts/Dashboard/components/NextAppointment'
import AnytimeWidget from '@/layouts/Dashboard/components/AnytimeWidget'
import BillingDetailsModal from '@/layouts/Dashboard/components/BillingDetailsModal'
import config from '@/config.js'

import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        //VuePullRefresh,
        PullRefresh,
        Navbar,
        Footer,
        NextAppointment,
        AnytimeWidget,
        PaymentModal,
        MeetingJoinModal,
        UiNotification,
        MaintenancePage,
        BillingDetailsModal
    },
    data() {
        return {
            items: [],
            role: 'member',
            styles: {
                sidebar: {
                    active: false
                },
                overlay: {
                    active: false
                },
                container: {
                    paddingLeft: '0px'
                },
                closeIcon: {
                    active: false
                }
            },
            windowWidth: 0,
            showMeetingJoin: false,
            widgetInterval: null,
            showMeetingJoin: false,
            notificationsSubscribed: false,
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user', // Current logged user
            services: 'user/services',
            // specialist: 'specialist/specialist', // Selected specialist page
            widget: 'layout/widget', // Current user's appointment
            // meeting: 'meeting/meeting', // Current appointment's meeting
            paymentModal: 'payments/modal', // Active or not active payment modal
            // meetingStatus: 'meeting/status'
            maintenance: 'notification/maintenance',
            anytimeMeetingSidebarCounter: 'anytimeMeeting/sidebarCounter',
            anytimeWidget: 'layout/anytimeWidget'
        }),
        isSpecialistPage() {
            return this.$route.name === 'Specialist';
        },
    },
    watch: {
        '$route.name': { //**Do not display  chat on specific pages
            handler(newVal) {
                window.scrollTo(0, 0);

                function tawkDisplay() {
                    let doNotDisplayPages = [
                        'Specialist',
                        'Adaugă credite',
                        'Ședințe acum',
                    ];

                    return;

                    let tawkIframe = document.querySelectorAll("iframe[title='chat widget']");

                    if (tawkIframe.length > 0) {
                        if(doNotDisplayPages.includes(newVal)) {
                            tawkIframe.forEach((item) => {
                                item.style.setProperty("display", "none", "important");
                            });
                        } else {
                            tawkIframe.forEach((item) => {
                                item.style.display = null;
                            });
                        }
                    } else {
                        setTimeout(tawkDisplay, 3000);
                    }
                }

                let tawkIframe = document.querySelectorAll("iframe[title='chat widget']");

                if(tawkIframe.length > 0) {
                    tawkDisplay();
                } else {
                    setTimeout(tawkDisplay, 3000);
                }
            },
            immediate: true // make this watch function is called when component created
        },
        '$store.state.user.user.id': {
            handler(newVal){
                //Subscribe to global notifications channel (user-specific, format: role_userId)
                if(newVal != null && newVal != '' && !this.notificationsSubscribed) {
                    this.subscribeNotifications();
                }
            },
            immediate: false
        }
    },
    methods: {
         ...mapActions({
            fetchWidget: 'layout/widget', // Action that fetch current user appointment widget
            fetchUser: 'user/user',
            fetchAppointments: 'appointments/fetchAppointments',
            fetchLanguages: 'layout/fetchLanguages',
            fetchNewestNotifications: 'layout/fetchNewestNotifications',
            refreshNotificationsPage: 'notification/fetchNotifications',
        }),
        subscribeNotifications(){
                    this.notificationsSubscribed = true;
                    this.sockets.subscribe('notifications_'+this.$store.state.user.user.role+'_'+ this.$store.state.user.user.id, data => {
                        switch (data.event) {
                            case 'notification':
                                this.fetchNewestNotifications();
                                console.log('Notifications refreshed');

                                if(this.$route.path == '/notifications') {
                                    // Added by Andrei Preda - if the event takes new data then the state must be emptied
                                    this.$store.state.notification.allNotifications = [];
                                    this.$store.state.notification.lastNotificationsPageIndex = 1;
                                    this.$store.state.notification.currentNotificationsPageIndex = 1;
                                    
                                    // After we put again the data
                                    this.refreshNotificationsPage();
                                    window.scrollTo(0,0);
                                }
                                break;
                            case 'anytime':
                                // Update counter anytime
                                let audio = document.getElementById('anytime-new-user');
                                if(this.$store.state.anytimeMeeting.sidebarCounter && this.$store.state.anytimeMeeting.sidebarCounter < data.user_count || !this.$store.state.anytimeMeeting.sidebarCounter && data.user_count != 0){
                                    audio.play();
                                    //Notify (push)
                                    this.$store.state.notification.notification.icon = null;
                                    this.$store.state.notification.notification.title = null;
                                    setTimeout(() => {          
                                        this.$store.state.notification.notification.icon = 'info';
                                        this.$store.state.notification.notification.title = 'Atentie! Aveti un client nou in lista de asteptare.';
                                    }, 200)
                                }
                                this.$store.state.anytimeMeeting.sidebarCounter = data.user_count;
                                break;
                        }
                    });
                    
                    if(this.$store.state.user.user.role == 'specialist'){ //Request sidebar anytime user count from node server | won't work if you try to hack it as a client ;)
                        var queueName = this.$store.state.user.user.id + '_' + (this.$store.state.user.user.full_name).replace(/\s/g, '','') + '_queue';
                        console.log(queueName);
                        
                        this.$socket.emit('anytime_specialist', { 
                            event: 'sidebar', 
                            queue_channel: queueName
                        });
                    }
        },
        selectSidebarItem(item) {
            if (item.path === "/specialist/settings#disponibilitate") {
                this.$router.push('/specialist/settings?bottom#disponibilitate');
            } else {
                this.$router.push(item.path);
            }

            if(this.isMobile())
                this.toggleSidebar(false);
        },
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window
                .innerWidth < 1200) {
                this.$store.state.layout.isMobile = true;
                return true;
            }
            this.$store.state.layout.isMobile = false;
            return false;
        },
        toggleSidebar(event) {
            if(event == true) {
                this.styles.sidebar.active = true;
                this.styles.overlay.active = true;

                if (this.$store.state.layout.isMobile) {
                    document.body.style.overflow = 'hidden';
                }
            } else {
                this.styles.sidebar.active = false;
                this.styles.overlay.active = false;
                document.body.style.overflow = null;
            }
        },
        resizeWindow() {
            
            if (this.isMobile()) {
                this.styles.container.paddingLeft = '0px';
                this.styles.sidebar.active = false;
                this.styles.overlay.active = false;
                this.styles.closeIcon.active = true;
                document.body.style.overflow = null;
            } else { 
                this.styles.container.paddingLeft = '280px';
                this.styles.sidebar.active = true;
                this.styles.overlay.active = false;
                this.styles.closeIcon.active = false;
            }
        },
        showMeetingJoinModal() {
            this.showMeetingJoin = true;
            if(this.isMobile())
                this.toggleSidebar(false);
        },
        onRefresh: function() {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    window.location.reload();
                    resolve();
                }, 1000);
            });
        }
    },
    created() {
        var role = localStorage.getItem('role');
        this.$router.options.routes.forEach(route => {
            if ((route.role == role || route.role == null) && route.children) {
                for (var i = 0; i < route.children.length; i++) {
                    if (route.children[i].sidebar) {
                        if (route.role == null)
                            this.items.push({
                                name: route.children[i].name,
                                path: route.children[i].path,
                                role: route.children[i].role,
                                icon: route.children[i].icon,
                                hasCounter: route.children[i].hasCounter ? true : false
                            })
                        else
                            this.items.push({
                                name: route.children[i].name,
                                path: route.path + '/' + route.children[i].path,
                                role: route.children[i].role,
                                icon: route.children[i].icon,
                                hasCounter: route.children[i].hasCounter ? true : false
                            })
                    }
                }
            }
        })
    },
    mounted() {
        //TAWK.TO SCRIPT
        let filestackScript = document.createElement('script');
        filestackScript.setAttribute('src', '//static.filestackapi.com/filestack-js/3.x.x/filestack.min.js');
        document.head.appendChild(filestackScript);

         var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
         (function(){
         var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
         s1.async=true;
         s1.src='https://embed.tawk.to/60618d46f7ce18270934ea7c/1f1ugvmnl';
         s1.charset='UTF-8';
         s1.setAttribute('crossorigin','*');
         s0.parentNode.insertBefore(s1,s0);
         })();

        let tawkInterval = setInterval(function(){
          let tawkIframe = document.querySelectorAll("iframe[title='chat widget']");

          if(tawkIframe[0] !== undefined){
            tawkIframe[0].parentElement.style.zIndex = '20';
          } else {
            clearInterval(tawkInterval);
          }
        }, 3000)

        //-------------

        window.onresize = () => {
            this.resizeWindow();
        }
        this.resizeWindow();
        this.fetchUser();
        this.fetchWidget();

        //Specialist subscribe to new_appointment channel
        if(localStorage.getItem('role') == 'specialist')
            this.sockets.subscribe('new_appointment', data => {
                if(data.specialist_id == this.$store.state.user.user.id){
                    //Notify
                    this.$store.state.notification.notification.icon = null;
                    this.$store.state.notification.notification.title = null;
                    setTimeout(() => {          
                        this.$store.state.notification.notification.icon = 'info';
                        this.$store.state.notification.notification.title = 'Programare nouă!';
                        let audio = document.getElementById('new-appointment-audio');
                        audio.play();
                        this.fetchAppointments();
                        this.fetchWidget();
                    }, 200)
                }
            });
        
      //Subscribe to notifications channels
      if(!this.notificationsSubscribed && typeof this.$store.state.user.user.id === 'number') this.subscribeNotifications();
                
    }
}
</script>

<style lang="scss">
    @import "@/scss/main";
</style>
